module.exports = __webpack_public_path__ + "media/icons/field-notes-flag-0b2883e5.svg";